import { useRepositoryQuery } from '@mews-commander/data-access';
import { LocalizedTypography } from '@mews-commander/ui';
import { LocalizedText, useDialog } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Body, Button, Card, IconName, Stack, Tag } from '@optimus-web/core';
import { SecurityCardSkeleton } from '../components/SecurityCardSkeleton';
import { StatusTag } from '../components/StatusTag';
import { useOwnerIdQueryPayload } from '../queries/useOwnerId';
import { ConfigureDeviceAuthPanel } from './ConfigureDeviceAuthPanel/ConfigureDeviceAuthPanel';

export function DeviceAuthConfiguration() {
    const ownerIdPayload = useOwnerIdQueryPayload();
    const [deviceAuthConfigPanelProps, toggleConfigDeviceAuthPanel] = useDialog();
    const hasOpenDialog = deviceAuthConfigPanelProps.active;
    const { isLoading, data } = useRepositoryQuery('deviceAuthorization', 'getSettings', ownerIdPayload);

    if (isLoading) {
        return <SecurityCardSkeleton />;
    }

    return (
        <>
            <Card padding="200" variant={hasOpenDialog ? 'highlighted' : 'default'}>
                <Stack vertical spacing="200">
                    <Stack vertical spacing="100">
                        <Stack spacing="100" distribution="space-between" itemAlignment="center">
                            <Stack spacing="100" itemAlignment="center">
                                <LocalizedTypography
                                    textKey={TextKey.DeviceAuthConfiguration}
                                    textStyle="titleSmallStrong"
                                    as="div"
                                />
                                <Tag leadingIcon={IconName.Deployments} variant="primary">
                                    <LocalizedText textKey={TextKey.Beta} />
                                </Tag>
                            </Stack>

                            <StatusTag isEnabled={data?.deviceAuthorizationEnforced} />
                        </Stack>

                        <Body align="left">
                            <LocalizedText textKey={TextKey.DeviceAuthConfigurationDescription} />
                        </Body>
                    </Stack>
                    <Stack>
                        <Button variant="tertiary" size="small" onClick={toggleConfigDeviceAuthPanel} type="submit">
                            <LocalizedText textKey={TextKey.DeviceAuthConfigurationButton} />
                        </Button>
                    </Stack>
                </Stack>
            </Card>
            <ConfigureDeviceAuthPanel data={data} {...deviceAuthConfigPanelProps} />
        </>
    );
}
